import { useEffect, useRef, useState } from "react";
import type { Strings } from "../i18n/strings";

// ④ 가짜 과학 로딩 (핸드오프). 둥둥 뜨는 물결 라인(드로우온 루프) + 회전 문구 + 점 애니메이션.
const MIN_MS = 2300;

export default function Loading({ t, ready, onDone }: { t: Strings; ready: boolean; onDone: () => void }) {
  const [line, setLine] = useState(() => Math.floor(Math.random() * t.loadingLines.length));
  const startRef = useRef(Date.now());

  useEffect(() => {
    const id = setInterval(() => setLine((i) => (i + 1) % t.loadingLines.length), 560);
    return () => clearInterval(id);
  }, [t.loadingLines.length]);

  useEffect(() => {
    if (!ready) return;
    const elapsed = Date.now() - startRef.current;
    const id = setTimeout(onDone, Math.max(0, MIN_MS - elapsed));
    return () => clearTimeout(id);
  }, [ready, onDone]);

  return (
    <div className="screen loading">
      <div className="ld-line">
        <svg width="160" height="46" viewBox="0 0 160 46" fill="none">
          <path
            className="ld-path"
            d="M2 34 Q 22 34 30 20 T 56 28 Q 74 4 90 24 T 120 12 Q 140 36 158 16"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <p className="load-line">
        {t.loadingLines[line]}
        <span className="ld-dots" />
      </p>
    </div>
  );
}
